import { styled } from '@attentive-platform/stem-ui';

// -----------------------------------------------------------------------------
// index.jsx — loading fallback
// -----------------------------------------------------------------------------

export const RootStyles = {
  LoadingScreen: styled('div')(() => ({
    minHeight: '100vh',
    background: '#F5F5F5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#808080',
    fontSize: '14px'
  }))
};

// -----------------------------------------------------------------------------
// BrandMark (Beam logo + Scope form)
// -----------------------------------------------------------------------------

export const BrandMarkStyles = {
  Block: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    minWidth: 0
  })),
  Logo: styled('img', { shouldForwardProp: p => p !== 'compact' })(({ compact }) => ({
    display: 'block',
    width: 'auto',
    height: compact ? '28px' : '36px'
  })),
  Label: styled('span')(() => ({
    fontSize: '13px',
    fontWeight: 500,
    color: '#666666',
    letterSpacing: '.02em'
  }))
};

// -----------------------------------------------------------------------------
// SavedLabel
// -----------------------------------------------------------------------------

export const SavedLabelStyles = {
  Wrap: styled('span')(() => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    color: '#808080',
    whiteSpace: 'nowrap'
  })),
  Dot: styled('span')(() => ({
    width: '6px',
    height: '6px',
    borderRadius: '3px',
    background: '#3E8E41',
    flex: 'none'
  }))
};

// -----------------------------------------------------------------------------
// ConfirmModal
// -----------------------------------------------------------------------------

export const ConfirmModalStyles = {
  ContentWrap: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    padding: '8px 16px 16px'
  })),
  Actions: styled('div')(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    paddingTop: '4px'
  }))
};

// -----------------------------------------------------------------------------
// InvalidTokenScreen
// -----------------------------------------------------------------------------

export const InvalidTokenScreenStyles = {
  PageWrap: styled('div')(() => ({
    minHeight: '100vh',
    background: '#F5F5F5',
    display: 'flex',
    justifyContent: 'center',
    padding: '80px 24px'
  })),
  Content: styled('div')(() => ({
    width: '100%',
    maxWidth: '620px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  })),
  BrandRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '25px',
    color: '#666666',
    fontSize: '16px',
    letterSpacing: '.02em',
    textTransform: 'uppercase'
  })),
  BrandName: styled('span')(() => ({
    fontSize: '17px',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    color: '#09185D',
    textTransform: 'none'
  })),
  Card: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #EBEBEB',
    borderRadius: '16px',
    padding: '40px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  })),
  Heading: styled('h2')(() => ({
    margin: 0,
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '-0.01em'
  })),
  Paragraph: styled('p')(() => ({
    margin: 0,
    fontSize: '15px',
    lineHeight: 1.55,
    color: '#4D4D4D'
  })),
  ReasonBox: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#9E9E9E',
    background: '#FAFAFA',
    border: '1px solid #F0F0F0',
    borderRadius: '10px',
    padding: '10px 12px'
  }))
};

// -----------------------------------------------------------------------------
// DoneScreen
// -----------------------------------------------------------------------------

export const DoneScreenStyles = {
  PageWrap: styled('div')(() => ({
    minHeight: '100vh',
    background: '#F5F5F5',
    display: 'flex',
    justifyContent: 'center',
    padding: '80px 24px'
  })),
  Content: styled('div')(() => ({
    width: '100%',
    maxWidth: '620px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  })),
  BrandRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: '#666666',
    fontSize: '13px',
    letterSpacing: '.02em',
    textTransform: 'uppercase'
  })),
  BrandName: styled('span')(() => ({
    fontSize: '17px',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    color: '#09185D',
    textTransform: 'none'
  })),
  Card: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #EBEBEB',
    borderRadius: '16px',
    padding: '40px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  })),
  CheckBadge: styled('div')(() => ({
    width: '44px',
    height: '44px',
    borderRadius: '22px',
    background: '#EDF7EE',
    color: '#3E8E41',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px'
  })),
  TitleBlock: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  })),
  Heading: styled('h2')(() => ({
    margin: 0,
    fontSize: '26px',
    fontWeight: 600,
    letterSpacing: '-0.01em'
  })),
  Paragraph: styled('p')(() => ({
    margin: 0,
    fontSize: '15px',
    lineHeight: 1.55,
    color: '#4D4D4D'
  })),
  FiledUnderBox: styled('div')(() => ({
    background: '#FAFAFA',
    border: '1px solid #F0F0F0',
    borderRadius: '12px',
    padding: '16px 18px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  })),
  Uppercase: styled('span')(() => ({
    fontSize: '12px',
    color: '#808080',
    letterSpacing: '.03em',
    textTransform: 'uppercase'
  })),
  EmailBig: styled('span')(() => ({
    fontSize: '17px',
    fontWeight: 600
  })),
  SmallGrey: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#666666'
  })),
  NextStepsBlock: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  })),
  NextStepsTitle: styled('span')(() => ({
    fontSize: '15px',
    fontWeight: 600
  })),
  BulletRow: styled('div')(() => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'flex-start'
  })),
  Bullet: styled('span')(() => ({
    width: '6px',
    height: '6px',
    borderRadius: '3px',
    background: '#A2B1F6',
    marginTop: '7px',
    flex: 'none'
  })),
  BulletText: styled('span')(() => ({
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#4D4D4D'
  })),
  PdfCallout: styled('div')(() => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'flex-start',
    background: '#F6F7FE',
    border: '1px solid #D0D8FB',
    borderRadius: '12px',
    padding: '14px 16px'
  })),
  PdfDot: styled('span')(() => ({
    width: '7px',
    height: '7px',
    borderRadius: '4px',
    background: '#4361EE',
    marginTop: '7px',
    flex: 'none'
  })),
  PdfText: styled('span')(() => ({
    fontSize: '13.5px',
    lineHeight: 1.5,
    color: '#4D4D4D'
  })),
  AeHint: styled('span')(() => ({
    fontSize: '13px',
    color: '#808080'
  }))
};

// -----------------------------------------------------------------------------
// ModifierInput
// -----------------------------------------------------------------------------

const modifierChipBase = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: '13px',
  borderRadius: '999px',
  padding: '4px 12px'
}));

export const ModifierInputStyles = {
  Section: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  })),
  HeaderRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap'
  })),
  Title: styled('span')(() => ({
    fontSize: '13.5px',
    fontWeight: 500,
    color: '#4D4D4D'
  })),
  BodyText: styled('span')(() => ({
    fontSize: '13px',
    lineHeight: 1.5,
    color: '#666666',
    maxWidth: '70ch'
  })),
  AdvancedPill: styled('span')(() => ({
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '11.5px',
    color: '#4D4D4D',
    background: '#F5F5F5',
    border: '1px solid #EBEBEB',
    borderRadius: '4px',
    padding: '1px 6px',
    whiteSpace: 'nowrap'
  })),
  ChipRow: styled('div')(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  })),
  ChipOn: styled(modifierChipBase)(() => ({
    fontWeight: 500,
    color: '#112FBB',
    background: '#E3E8FC',
    border: '1px solid #B9C5F8',
    cursor: 'pointer'
  })),
  ChipOff: styled(modifierChipBase)(() => ({
    fontWeight: 400,
    color: '#4D4D4D',
    background: '#F5F5F5',
    border: '1px solid #E0E0E0',
    cursor: 'pointer'
  })),
  ChipDisabled: styled(modifierChipBase)(() => ({
    fontWeight: 400,
    color: '#4D4D4D',
    background: '#F5F5F5',
    border: '1px solid #E0E0E0',
    opacity: 0.6
  })),
  SelectWrap: styled('div')(() => ({ maxWidth: '520px' })),
  InputWrap: styled('div')(() => ({ maxWidth: '520px' })),
  ExampleLinks: styled('div')(() => ({
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap'
  })),
  ExampleLink: styled('a')(() => ({
    fontSize: '13px',
    color: '#4361EE',
    textDecoration: 'none',
    border: '1px solid #E3E8FC',
    background: '#F6F7FE',
    borderRadius: '8px',
    padding: '6px 12px'
  }))
};

// -----------------------------------------------------------------------------
// TradeDetailingBlock
// -----------------------------------------------------------------------------

export const TradeDetailingBlockStyles = {
  Card: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    background: '#FFFFFF',
    border: '1px solid #EBEBEB',
    borderRadius: '14px',
    padding: '28px'
  })),
  Header: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  })),
  Heading: styled('h3')(() => ({
    margin: 0,
    fontSize: '20px',
    fontWeight: 600,
    letterSpacing: '-0.005em'
  })),
  Description: styled('p')(() => ({
    margin: 0,
    fontSize: '14px',
    lineHeight: 1.5,
    color: '#666666',
    maxWidth: '70ch'
  })),
  ModifierRow: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    paddingTop: '20px',
    borderTop: '1px solid #F0F0F0'
  })),
  NoteBlock: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    paddingTop: '20px',
    borderTop: '1px solid #F0F0F0'
  })),
  NoteTitle: styled('span')(() => ({
    fontSize: '15px',
    fontWeight: 600
  })),
  NoteHint: styled('span')(() => ({
    fontSize: '13px',
    color: '#666666'
  }))
};

// -----------------------------------------------------------------------------
// ScopeItem
// -----------------------------------------------------------------------------

const scopeChipBase = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: '13px',
  borderRadius: '999px',
  padding: '4px 12px'
}));

export const ScopeItemStyles = {
  CardOn: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #B9C5F8',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 2px 6px rgba(9,24,93,.05)',
    marginBottom: '8px'
  })),
  CardOff: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #EBEBEB',
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '8px'
  })),
  HeadRowClickable: styled('div')(() => ({
    display: 'flex',
    padding: '10px 20px',
    alignItems: 'center',
    cursor: 'pointer'
  })),
  HeadRowStatic: styled('div')(() => ({
    display: 'flex',
    padding: '10px 20px',
    alignItems: 'center',
    cursor: 'default'
  })),
  CheckboxWrap: styled('div')(() => ({ paddingTop: '1px' })),
  HeadBody: styled('div')(() => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  })),
  TitleRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap'
  })),
  Title: styled('span')(() => ({
    fontSize: '15.5px',
    fontWeight: 500
  })),
  AdvancedPill: styled('span')(() => ({
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '11.5px',
    color: '#4D4D4D',
    background: '#F5F5F5',
    border: '1px solid #EBEBEB',
    borderRadius: '4px',
    padding: '1px 6px',
    whiteSpace: 'nowrap'
  })),
  Description: styled('span')(() => ({
    fontSize: '13.5px',
    lineHeight: 1.45,
    color: '#666666'
  })),
  ExpandedBlock: styled('div')(() => ({
    borderTop: '1px solid #F0F0F0',
    background: '#FCFCFD',
    padding: '20px 20px 22px 52px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  })),
  ElementsSection: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  })),
  ElementsHeader: styled('div')(() => ({
    display: 'flex',
    alignItems: 'baseline',
    gap: '10px'
  })),
  ElementsHeading: styled('span')(() => ({
    fontSize: '14px',
    fontWeight: 600
  })),
  CountLabel: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#808080'
  })),
  ChipRow: styled('div')(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  })),
  ChipOn: styled(scopeChipBase)(() => ({
    fontWeight: 500,
    color: '#112FBB',
    background: '#E3E8FC',
    border: '1px solid #B9C5F8',
    cursor: 'pointer'
  })),
  ChipOff: styled(scopeChipBase)(() => ({
    fontWeight: 400,
    color: '#4D4D4D',
    background: '#F5F5F5',
    border: '1px solid #E0E0E0',
    cursor: 'pointer'
  })),
  ChipDisabled: styled(scopeChipBase)(() => ({
    fontWeight: 400,
    color: '#4D4D4D',
    background: '#F5F5F5',
    border: '1px solid #E0E0E0',
    opacity: 0.6
  })),
  AllOffWarning: styled('div')(() => ({
    background: '#FFFBF5',
    border: '1px solid #FFEACC',
    borderRadius: '10px',
    padding: '10px 12px',
    fontSize: '12.5px',
    color: '#995C00',
    lineHeight: 1.5
  })),
  ModifierSection: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '18px'
  })),
  ModifierHeading: styled('span')(() => ({
    fontSize: '14px',
    fontWeight: 600
  }))
};

// -----------------------------------------------------------------------------
// ExampleCards (scope-item example modifiers)
// -----------------------------------------------------------------------------

export const ExampleCardsStyles = {
  Section: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  })),
  Heading: styled('span')(() => ({
    fontSize: '13px',
    color: '#808080',
    letterSpacing: '.02em',
    textTransform: 'uppercase'
  })),
  Grid: styled('div')(() => ({
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
    alignItems: 'flex-start'
  })),
  Card: styled('button')(() => ({
    width: '260px',
    border: '1px solid #EBEBEB',
    borderRadius: '10px',
    overflow: 'hidden',
    background: '#FFFFFF',
    padding: 0,
    textAlign: 'left',
    cursor: 'pointer',
    font: 'inherit',
    color: 'inherit',
    '&:hover:not(:disabled)': {
      borderColor: '#B9C5F8',
      boxShadow: '0 2px 8px rgba(9,24,93,.06)'
    },
    '&:disabled': {
      cursor: 'default',
      opacity: 0.85
    }
  })),
  Thumb: styled('div')(() => ({
    width: '100%',
    height: '132px',
    background: '#F5F5F5',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  })),
  ThumbImg: styled('img')(() => ({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
  })),
  CardBody: styled('div')(() => ({
    padding: '10px 12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  })),
  CardTitle: styled('span')(() => ({
    fontSize: '13px',
    fontWeight: 500,
    color: '#1A1A1A'
  })),
  CardCaption: styled('span')(() => ({
    fontSize: '12px',
    color: '#808080'
  })),
  LinkChip: styled('button')(() => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    font: 'inherit',
    fontSize: '13px',
    color: '#4D4D4D',
    textDecoration: 'none',
    border: '1px solid #EBEBEB',
    background: '#F5F5F5',
    borderRadius: '8px',
    padding: '6px 12px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#D9D9D9',
      background: '#EFEFEF'
    }
  })),
  ChipDot: styled('span')(() => ({
    width: '3px',
    height: '3px',
    borderRadius: '50%',
    background: '#808080',
    flex: 'none'
  })),
  ChipIcon: styled('svg')(() => ({
    flex: 'none',
    display: 'block',
    color: '#4D4D4D'
  })),
  ModalBody: styled('div')(() => ({
    padding: '8px 16px 20px',
    display: 'flex',
    justifyContent: 'center',
    maxHeight: '70vh',
    overflow: 'auto'
  })),
  ModalImg: styled('img')(() => ({
    maxWidth: '100%',
    maxHeight: '65vh',
    objectFit: 'contain',
    borderRadius: '8px',
    display: 'block'
  }))
};

// -----------------------------------------------------------------------------
// SearchOmnibox
// -----------------------------------------------------------------------------

const searchPanelBase = styled('div')(() => ({
  position: 'absolute',
  top: '48px',
  left: 0,
  width: '460px',
  background: '#FFFFFF',
  border: '1px solid #EBEBEB',
  borderRadius: '12px',
  boxShadow: '0 12px 32px rgba(9,24,93,.12)',
  zIndex: 40
}));

export const SearchOmniboxStyles = {
  Wrap: styled('div')(() => ({
    position: 'relative'
  })),
  Panel: styled(searchPanelBase)(() => ({
    padding: '6px',
    maxHeight: '440px',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  })),
  NoResultsPanel: styled(searchPanelBase)(() => ({
    padding: '16px 18px',
    display: 'flex',
    flexDirection: 'column',
    gap: '3px'
  })),
  PanelLabel: styled('span')(() => ({
    fontSize: '11.5px',
    color: '#9E9E9E',
    letterSpacing: '.04em',
    textTransform: 'uppercase',
    padding: '8px 12px 4px'
  })),
  RowActive: styled('div')(() => ({
    padding: '9px 12px',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
    background: '#F6F7FE'
  })),
  RowIdle: styled('div')(() => ({
    padding: '9px 12px',
    borderRadius: '8px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    gap: '3px',
    background: 'transparent'
  })),
  RowTop: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap'
  })),
  KindBadge: styled('span')(() => ({
    fontSize: '10.5px',
    letterSpacing: '.05em',
    textTransform: 'uppercase',
    color: '#666666',
    background: '#F0F0F0',
    borderRadius: '4px',
    padding: '2px 6px'
  })),
  RowLabel: styled('span')(() => ({
    fontSize: '14px',
    fontWeight: 500
  })),
  CheckedPill: styled('span')(() => ({
    fontSize: '11px',
    color: '#112FBB',
    background: '#E3E8FC',
    borderRadius: '999px',
    padding: '2px 8px'
  })),
  RowPath: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#808080'
  })),
  Footer: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '9px 12px 5px',
    marginTop: '2px',
    borderTop: '1px solid #F5F5F5'
  })),
  HintText: styled('span')(() => ({
    fontSize: '11.5px',
    color: '#9E9E9E'
  })),
  NoResultsHeading: styled('span')(() => ({
    fontSize: '14px',
    fontWeight: 500
  })),
  NoResultsHint: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#808080'
  }))
};

// -----------------------------------------------------------------------------
// WelcomeScreen
// -----------------------------------------------------------------------------

export const WelcomeScreenStyles = {
  PageWrap: styled('div')(() => ({
    minHeight: '100vh',
    background: '#F5F5F5',
    padding: '56px 24px 96px',
    display: 'flex',
    justifyContent: 'center'
  })),
  Content: styled('div')(() => ({
    width: '100%',
    maxWidth: '760px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  })),
  BrandRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: '#666666',
    fontSize: '13px',
    letterSpacing: '.02em',
    textTransform: 'uppercase'
  })),
  BrandName: styled('span')(() => ({
    fontSize: '17px',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    color: '#09185D',
    textTransform: 'none'
  })),
  Card: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #EBEBEB',
    borderRadius: '16px',
    padding: '40px',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  })),
  TitleBlock: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  })),
  Headline: styled('h1')(() => ({
    margin: 0,
    fontSize: '34px',
    lineHeight: 1.2,
    fontWeight: 600,
    letterSpacing: '-0.01em'
  })),
  Lede: styled('p')(() => ({
    margin: 0,
    fontSize: '17px',
    lineHeight: 1.55,
    color: '#4D4D4D',
    maxWidth: '60ch'
  })),
  StatStrip: styled('div')(() => ({
    display: 'flex',
    gap: '28px',
    flexWrap: 'wrap',
    padding: '16px 0',
    borderTop: '1px solid #F0F0F0',
    borderBottom: '1px solid #F0F0F0'
  })),
  StatCol: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  })),
  StatLabel: styled('span')(() => ({
    fontSize: '12px',
    color: '#808080',
    letterSpacing: '.03em',
    textTransform: 'uppercase'
  })),
  StatValue: styled('span')(() => ({
    fontSize: '15px',
    fontWeight: 500
  })),
  StatHint: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#9E9E9E'
  })),
  StepsGrid: styled('div')(() => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    gap: '12px',
    marginTop: '4px'
  })),
  StepCard: styled('div')(() => ({
    background: '#FAFAFA',
    border: '1px solid #F0F0F0',
    borderRadius: '12px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  })),
  StepBadge: styled('span')(() => ({
    width: '22px',
    height: '22px',
    borderRadius: '11px',
    background: '#E3E8FC',
    color: '#112FBB',
    fontSize: '12px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  })),
  StepTitle: styled('span')(() => ({
    fontSize: '14px',
    fontWeight: 600
  })),
  StepBody: styled('span')(() => ({
    fontSize: '13px',
    lineHeight: 1.45,
    color: '#666666'
  })),
  EmailBlock: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    maxWidth: '420px',
    marginTop: '4px'
  })),
  InputLabel: styled('span')(() => ({
    fontSize: '13px',
    fontWeight: 500,
    color: '#4D4D4D'
  })),
  WelcomeBack: styled('div')(() => ({
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-start',
    background: '#F6F7FE',
    border: '1px solid #D0D8FB',
    borderRadius: '12px',
    padding: '14px 16px',
    marginTop: '4px'
  })),
  WelcomeBackDot: styled('span')(() => ({
    width: '7px',
    height: '7px',
    borderRadius: '4px',
    background: '#4361EE',
    marginTop: '7px',
    flex: 'none'
  })),
  WelcomeBackText: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '3px'
  })),
  WelcomeBackTitle: styled('span')(() => ({
    fontSize: '14px',
    fontWeight: 600
  })),
  WelcomeBackBody: styled('span')(() => ({
    fontSize: '13px',
    lineHeight: 1.5,
    color: '#4D4D4D'
  })),
  Disclaimer: styled('div')(() => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'flex-start',
    background: '#FAFAFA',
    border: '1px solid #F0F0F0',
    borderRadius: '10px',
    padding: '12px 14px'
  })),
  DisclaimerDot: styled('span')(() => ({
    width: '6px',
    height: '6px',
    borderRadius: '3px',
    background: '#A2B1F6',
    marginTop: '7px',
    flex: 'none'
  })),
  DisclaimerText: styled('span')(() => ({
    fontSize: '13px',
    lineHeight: 1.5,
    color: '#4D4D4D'
  })),
  StartRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginTop: '8px'
  })),
  StartHint: styled('span')(() => ({
    fontSize: '13px',
    color: '#808080'
  }))
};

// -----------------------------------------------------------------------------
// ReviewScreen
// -----------------------------------------------------------------------------

export const ReviewScreenStyles = {
  PageWrap: styled('div')(() => ({
    minHeight: '100vh',
    background: '#F5F5F5'
  })),
  TopBar: styled('div')(() => ({
    position: 'sticky',
    top: 0,
    zIndex: 20,
    background: '#FFFFFF',
    borderBottom: '1px solid #EBEBEB'
  })),
  TopBarInner: styled('div')(() => ({
    maxWidth: '1080px',
    margin: '0 auto',
    padding: '12px 32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  })),
  BrandRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minWidth: 0
  })),
  Divider: styled('span')(() => ({
    width: '1px',
    height: '20px',
    background: '#9E9E9E',
  })),
  Subtitle: styled('span')(() => ({
    fontSize: '15px',
    fontWeight: 600,
    color: '#1A1A1A'
  })),
  Body: styled('div')(() => ({
    maxWidth: '1080px',
    margin: '0 auto',
    padding: '32px 32px 96px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  })),
  IntroBlock: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  })),
  Heading: styled('h2')(() => ({
    margin: 0,
    fontSize: '26px',
    fontWeight: 600,
    letterSpacing: '-0.01em'
  })),
  IntroSubtitle: styled('p')(() => ({
    margin: 0,
    fontSize: '15px',
    color: '#4D4D4D'
  })),
  SkippedNote: styled('span')(() => ({
    fontSize: '13px',
    color: '#808080',
    lineHeight: 1.5
  })),
  EmptyStateCard: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #EBEBEB',
    borderRadius: '14px',
    padding: '28px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    alignItems: 'flex-start'
  })),
  EmptyStateTitle: styled('span')(() => ({
    fontSize: '15px',
    fontWeight: 600
  })),
  EmptyStateBody: styled('span')(() => ({
    fontSize: '13.5px',
    color: '#666666'
  })),
  TradeCard: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #EBEBEB',
    borderRadius: '14px',
    overflow: 'hidden'
  })),
  TradeHead: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '18px 24px',
    borderBottom: '1px solid #F0F0F0'
  })),
  TradeHeadLeft: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  })),
  TradeName: styled('span')(() => ({
    fontSize: '18px',
    fontWeight: 600,
    whiteSpace: 'nowrap'
  })),
  CountLabel: styled('span')(() => ({
    fontSize: '13px',
    color: '#808080'
  })),
  SectionBlock: styled('div')(() => ({
    padding: '18px 24px',
    borderBottom: '1px solid #F5F5F5',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px'
  })),
  Uppercase: styled('span')(() => ({
    fontSize: '12px',
    color: '#808080',
    letterSpacing: '.03em',
    textTransform: 'uppercase'
  })),
  ItemRow: styled('div')(() => ({
    display: 'grid',
    gridTemplateColumns: '260px minmax(0,1fr)',
    gap: '20px',
    padding: '12px 0',
    borderTop: '1px solid #F5F5F5'
  })),
  ItemLabelCol: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  })),
  ItemLabel: styled('span')(() => ({
    fontSize: '14.5px',
    fontWeight: 500
  })),
  ItemCounter: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#808080'
  })),
  ItemValueCol: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  })),
  ElementsLine: styled('span')(() => ({
    fontSize: '13.5px',
    lineHeight: 1.5,
    color: '#4D4D4D'
  })),
  ModifierLine: styled('div')(() => ({
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap'
  })),
  ModifierKey: styled('span')(() => ({
    fontSize: '13.5px',
    color: '#808080'
  })),
  ModifierVal: styled('span')(() => ({
    fontSize: '13.5px',
    fontWeight: 500
  })),
  DetailingBlock: styled('div')(() => ({
    padding: '18px 24px',
    background: '#FCFCFD',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  })),
  NoteBlock: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginTop: '6px'
  })),
  NoteLabel: styled('span')(() => ({
    fontSize: '13.5px',
    color: '#808080'
  })),
  NoteText: styled('span')(() => ({
    fontSize: '13.5px',
    lineHeight: 1.5,
    whiteSpace: 'pre-wrap'
  })),
  ExclusionsWrap: styled('div')(() => ({
    padding: '16px 24px 20px',
    borderTop: '1px solid #F0F0F0'
  })),
  SubmitCard: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #EBEBEB',
    borderRadius: '14px',
    padding: '28px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  })),
  SubmitHead: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  })),
  SubmitTitle: styled('span')(() => ({
    fontSize: '16px',
    fontWeight: 600
  })),
  SubmitBody: styled('span')(() => ({
    fontSize: '13.5px',
    color: '#666666'
  })),
  EmailBlock: styled('div')(() => ({
    maxWidth: '420px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  })),
  InputLabel: styled('span')(() => ({
    fontSize: '13px',
    fontWeight: 500,
    color: '#4D4D4D'
  })),
  ErrorBanner: styled('span')(() => ({
    fontSize: '13px',
    color: '#C1180B',
    background: '#FFF0EE',
    border: '1px solid #F8C4BF',
    borderRadius: '8px',
    padding: '10px 12px'
  })),
  SubmitRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  })),
  SubmitHint: styled('span')(() => ({
    fontSize: '13px',
    color: '#808080'
  })),
  ReadOnlyCard: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #EBEBEB',
    borderRadius: '14px',
    padding: '24px 28px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  })),
  ReadOnlyTitle: styled('span')(() => ({
    fontSize: '15px',
    fontWeight: 600
  })),
  ReadOnlyBody: styled('span')(() => ({
    fontSize: '13.5px',
    lineHeight: 1.5,
    color: '#666666'
  }))
};

// -----------------------------------------------------------------------------
// FormScreen
// -----------------------------------------------------------------------------

export const FormScreenStyles = {
  PageWrap: styled('div')(() => ({
    minHeight: '100vh',
    background: '#F5F5F5'
  })),
  BannerSubmitted: styled('div')(() => ({
    background: '#F4F9F5',
    borderBottom: '1px solid #CBE3CD'
  })),
  BannerReopened: styled('div')(() => ({
    background: '#F6F7FE',
    borderBottom: '1px solid #D0D8FB'
  })),
  BannerInner: styled('div')(() => ({
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '14px 32px',
    display: 'flex',
    alignItems: 'center',
    gap: '14px'
  })),
  BannerTagSubmitted: styled('span')(() => ({
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '.05em',
    textTransform: 'uppercase',
    color: '#3E8E41',
    border: '1px solid #CBE3CD',
    borderRadius: '999px',
    padding: '3px 10px',
    background: '#FFFFFF',
    flex: 'none'
  })),
  BannerTagReopened: styled('span')(() => ({
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '.05em',
    textTransform: 'uppercase',
    color: '#112FBB',
    border: '1px solid #D0D8FB',
    borderRadius: '999px',
    padding: '3px 10px',
    background: '#FFFFFF',
    flex: 'none'
  })),
  BannerTitle: styled('span')(() => ({
    fontSize: '14px',
    fontWeight: 600
  })),
  BannerBody: styled('span')(() => ({
    fontSize: '13.5px',
    color: '#4D4D4D'
  })),
  TopBar: styled('div')(() => ({
    position: 'sticky',
    top: 0,
    zIndex: 20,
    background: '#FFFFFF',
    borderBottom: '1px solid #EBEBEB'
  })),
  TopBarInner: styled('div')(() => ({
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '12px 32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '24px'
  })),
  BrandRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    minWidth: 0,
    flex: 'none'
  })),
  Divider: styled('span')(() => ({
    width: '1px',
    height: '20px',
    background: '#EBEBEB',
    flex: 'none'
  })),
  HeaderTitle: styled('span')(() => ({
    fontSize: '15px',
    fontWeight: 600,
    color: '#1A1A1A',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '320px'
  })),
  TopBarRight: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '20px'
  })),
  PickedLabel: styled('span')(() => ({
    fontSize: '13px',
    color: '#666666',
    whiteSpace: 'nowrap'
  })),
  RailTradeWrap: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  })),
  RailTradeRow: styled('div')(({ active }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '9px 10px',
    borderRadius: '8px',
    cursor: 'pointer',
    background: active ? '#F6F7FE' : 'transparent',
    borderLeft: `3px solid ${active ? '#4361EE' : 'transparent'}`,
    '&:hover': { background: '#F6F7FE' }
  })),
  RailTradeName: styled('span')(({ active }) => ({
    fontSize: '13.5px',
    fontWeight: active ? 600 : 500,
    color: active ? '#112FBB' : '#1A1A1A',
    flex: 1,
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  })),
  RailSectionList: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1px',
    padding: '2px 0 8px 16px',
    borderLeft: '1px solid #EBEBEB',
    marginLeft: '12px'
  })),
  RailSectionRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    padding: '6px 10px',
    borderRadius: '7px',
    cursor: 'pointer',
    '&:hover': { background: '#F0F0F0' }
  })),
  RailSectionCount: styled('span')(() => ({
    fontSize: '11.5px',
    color: '#9E9E9E',
    flex: 'none'
  })),
  Layout: styled('div')(() => ({
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '32px',
    display: 'grid',
    gridTemplateColumns: '248px minmax(0,1fr)',
    gap: '40px',
    alignItems: 'start'
  })),
  Rail: styled('div')(() => ({
    position: 'sticky',
    top: '132px',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  })),
  RailHeading: styled('span')(() => ({
    fontSize: '12px',
    color: '#808080',
    letterSpacing: '.03em',
    textTransform: 'uppercase',
    padding: '0 10px 8px'
  })),
  RailRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '8px 10px',
    borderRadius: '8px',
    cursor: 'pointer'
  })),
  RailDotOn: styled('span')(() => ({
    width: '8px',
    height: '8px',
    borderRadius: '4px',
    flex: 'none',
    background: '#4361EE'
  })),
  RailDotOff: styled('span')(() => ({
    width: '8px',
    height: '8px',
    borderRadius: '4px',
    flex: 'none',
    background: '#D9D9D9'
  })),
  RailName: styled('span')(() => ({
    fontSize: '13.5px',
    lineHeight: 1.35,
    color: '#4D4D4D',
    flex: 1
  })),
  RailCount: styled('span')(() => ({
    fontSize: '12px',
    color: '#9E9E9E'
  })),
  Main: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '28px',
    maxWidth: '900px'
  })),
  IntroCard: styled('div')(() => ({
    background: '#FFFFFF',
    border: '1px solid #EBEBEB',
    borderRadius: '14px',
    padding: '24px 28px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  })),
  IntroHead: styled('div')(() => ({
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '16px'
  })),
  IntroTitle: styled('h2')(() => ({
    margin: 0,
    fontSize: '24px',
    fontWeight: 600,
    letterSpacing: '-0.01em'
  })),
  ClearTradeBtn: styled('span')(() => ({
    fontSize: '13px',
    fontWeight: 500,
    color: '#4D4D4D',
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    padding: '7px 12px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    flex: 'none'
  })),
  IntroDesc: styled('p')(() => ({
    margin: 0,
    fontSize: '15px',
    lineHeight: 1.55,
    color: '#4D4D4D',
    maxWidth: '70ch',
    whiteSpace: 'pre-wrap'
  })),
  IntroHint: styled('span')(() => ({
    fontSize: '13px',
    color: '#808080'
  })),
  ExclusionsCard: styled('div')(() => ({
    background: '#FAFAFA',
    border: '1px solid #EBEBEB',
    borderRadius: '12px',
    padding: '20px 22px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  })),
  ExclusionsTitle: styled('span')(() => ({
    fontSize: '13px',
    fontWeight: 600,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: '#666666'
  })),
  ExclusionsNote: styled('p')(() => ({
    margin: 0,
    fontSize: '13.5px',
    lineHeight: 1.5,
    color: '#4D4D4D'
  })),
  ExclusionsList: styled('ul', { shouldForwardProp: p => p !== 'twoCol' })(({ twoCol }) => ({
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'grid',
    gridTemplateColumns: twoCol ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)',
    gap: twoCol ? '8px 28px' : '8px',
    columnGap: twoCol ? '28px' : undefined
  })),
  ExclusionsItem: styled('li')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    paddingLeft: '14px',
    position: 'relative',
    '&::before': {
      content: '"•"',
      position: 'absolute',
      left: 0,
      top: 0,
      color: '#808080',
      fontSize: '14px',
      lineHeight: 1.5
    }
  })),
  ExclusionsText: styled('span')(() => ({
    fontSize: '13.5px',
    lineHeight: 1.5,
    color: '#4D4D4D'
  })),
  ExclusionsSubText: styled('span')(() => ({
    fontSize: '12.5px',
    lineHeight: 1.45,
    color: '#808080',
    paddingLeft: '2px'
  })),
  SectionBlock: styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  })),
  SectionHeaderRow: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    paddingTop: '8px'
  })),
  SectionName: styled('span')(() => ({
    fontSize: '16px',
    fontWeight: 600,
    letterSpacing: '-0.005em'
  })),
  SectionHR: styled('span')(() => ({
    height: '1px',
    flex: 1,
    background: '#EBEBEB'
  })),
  SectionCount: styled('span')(() => ({
    fontSize: '12.5px',
    color: '#808080'
  })),
  Footer: styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    padding: '4px 0 40px'
  })),
  FooterHint: styled('span')(() => ({
    fontSize: '13px',
    color: '#808080'
  })),
  FooterActions: styled('div')(() => ({
    display: 'flex',
    gap: '12px'
  }))
};
